module.exports = ":host ::ng-deep #okta-sign-in .o-form-has-errors .o-form-explain.o-form-input-error {\n  display: none !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/new-login-widget/new-login-widget-header/new-login-widget-header.component.scss
// module id = ./src/app/new-login-widget/new-login-widget-header/new-login-widget-header.component.scss
// module chunks = main